import React, { useState } from "react";
import { MotifDropdown, MotifDropdownItem } from "@ey-xd/motif-react";
import { useI18n } from "../../hooks/useI18n";
import "./LanguageDropdown.scss";
import { GlobeIcon } from "../../icons";

const languages = [
  { code: "en", name: "English", flag: "🇺🇸" },
  { code: "ja", name: "Japanese", flag: "🇯🇵" },
];

export const LanguageDropdown = () => {
  const { currentLanguage, changeLanguage } = useI18n();
  const [isOpen, setIsOpen] = useState(false);
  const triggerId = "language-dropdown-trigger";

  const currentLang =
    languages.find((lang) => lang.code === currentLanguage) || languages[0];

  const handleLanguageChange = (langCode) => {
    changeLanguage(langCode);
    setIsOpen(false);
  };

  return (
    <MotifDropdown
      ariaLabelledby={triggerId}
      handleOnClose={() => setIsOpen(false)}
      onClick={() => setIsOpen(!isOpen)}
      open={isOpen}
      placement="left"
      trigger={
        <button
          className="language-dropdown-trigger"
          id={triggerId}
          aria-label="Select Language"
        >
          <span className="globe-icon">
            <GlobeIcon />
          </span>
          <span className="language-text">
            {currentLang.code.toUpperCase()}
          </span>
        </button>
      }
    >
      {languages.map((lang, index) => (
        <MotifDropdownItem
          key={lang.code}
          indexItem={index + 1}
          aria-label={`Select ${lang.name}`}
          onClick={() => handleLanguageChange(lang.code)}
          className={currentLanguage === lang.code ? "active" : ""}
        >
          <div className="language-item">
            <span className="language-flag">{lang.flag}</span>
            <span className="language-name">{lang.name}</span>
          </div>
        </MotifDropdownItem>
      ))}
    </MotifDropdown>
  );
};
